import React, { Component } from "react";
import Chart from "chart.js";
import { GetKPIData } from "../Actions/CommonAPI";

class HazardousChart extends Component {

  constructor(props) {
    super(props);
    this.createChart = this.createChart.bind(this);
  }

  componentDidMount(){
    const { dashboardData } = this.props;
    this.createChart(dashboardData);
  }

  componentDidUpdate() {
    const { dashboardData } = this.props;
    this.createChart(dashboardData);
  }
  
  createChart(dashboardData) {

    var chart = this.refs.learner;
    let data = dashboardData ? [dashboardData.totalHazardousPOsValidated, dashboardData.totalHazardousPOsIdentified] : [0, 0]

    var newChart = new Chart(chart, {
      type: 'horizontalBar',
      data: {
          labels: ['Hazardous PO\'s validated', 'Hazardous PO\'x identified'],
          datasets: [{
              axis: 'y',
              label: 'KPI for Hazardous POs - Validated within 1 day',
              data: data,
              barPercentage: 0.3,
              backgroundColor: [
                  '#f5b083',
                  '#ff0102',
              ],
              borderColor: [
                  '#f5b083',
                  '#ff0102',
              ],
              borderWidth: 1
          }]
      },
      options: {
          scales: {
              y: {
                  beginAtZero: false
              },
              xAxes: [{
                ticks: {
                    min: 0, // Edit the value according to what you need
                },
                interval: 20
              }],
              yAxes: [{
                  stacked: true
              }]
          },
          indexAxis: 'y',
          legend: {
            onClick: (e) => e.stopPropagation()
        }
      }
  });
  
  }

  render() {

    return (
      // <div class="myChart">
        <canvas
          ref="learner"
          width="400" 
          height="250"
        ></canvas>
      // </div>
      
    );
  }
}

export default HazardousChart;
